import { useState } from "react";

import styles from "./Accordion.module.css";

type AccordionItemProps = {
  question: string;
  answer: string;
  open: boolean;
  onToggle: () => void;
};

export function AccordionItem({
  question,
  answer,
  open,
  onToggle,
}: AccordionItemProps) {
  const panelId = `faq-panel-${question.replace(/\s+/gu, "-").slice(0, 40)}`;

  return (
    <div className={styles.item}>
      <button
        type="button"
        className={styles.trigger}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span>{question}</span>
        <span className={styles.chevron} aria-hidden="true">
          {open ? "−" : "+"}
        </span>
      </button>
      {open ? (
        <div id={panelId} className={styles.panel} role="region">
          <p>{answer}</p>
        </div>
      ) : null}
    </div>
  );
}

type AccordionProps = {
  items: { question: string; answer: string }[];
};

export function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className={styles.list}>
      {items.map((item, index) => (
        <AccordionItem
          key={item.question}
          question={item.question}
          answer={item.answer}
          open={openIndex === index}
          onToggle={() => {
            setOpenIndex(openIndex === index ? null : index);
          }}
        />
      ))}
    </div>
  );
}
